
<div>
  <div
    class="p-1 rounded cursor-pointer board-dp"
    :class="{ 'bg-gray': disabled, 'bg-white': !disabled }"
    style="border: solid 1px #ccc"
    ref="date"
  >
    <div v-if="value">
      <i class="far fa-clock mr-2"></i>
      <span v-if="mode === 'date' && isRange">{{ value | formatRangeDate }}</span>
      <span v-else-if="mode === 'dateTime'">{{ value | formatDateTime }}</span>
      <span v-else>{{ value | formatDateWithoutHours }}</span>
    </div>
    <div v-else>No date set</div>
  </div>

  <b-popover
    :custom-class="customClass"
    ref="datePopover"
    :disabled="disabled"
    :target="() => $refs.date"
    triggers="click blur"
    :placement="popoverPlacement"
    v-on:shown="shown"
    v-on:hidden="hidden"
  >
    <div class="d-flex mb-2" v-if="displayQuickAddHours">
      <button class="btn btn-success btn-sm flex-grow-1" @click="quickAddHours(1)">
        <i class="far fa-clock mr-2"></i>
        + 1h from now
      </button>
      <button class="btn btn-success btn-sm flex-grow-1 ml-2" @click="quickAddHours(8)">
        <i class="far fa-clock mr-2"></i>
        + 8h from now
      </button>
    </div>

    <v-date-picker
      v-model="innerValue"
      trim-weeks
      :mode="mode"
      :minute-increment="5"
      :model-config="{ type: 'string' }"
      is24hr
      :timezone="userTimezone"
      :is-range="isRange"
      :columns="$screens({ default: columns })"
      :min-date="minDate"
      :attributes="attributes"
    ></v-date-picker>

    <div>
      <div class="mt-2 text-center" v-if="this.mode === 'dateTime'">
        <small>
          Time in
          <span class="text-uppercase">{{ userStore.user.timeZone }}</span>
        </small>
      </div>

      <div class="mt-2 d-flex justify-content-between">
        <div>
          <button class="btn btn-secondary btn-sm mr-2" @click="cancel">
            <i class="far fa-times mr-2"></i>
            Cancel
          </button>
          <button class="btn btn-danger btn-sm" @click="removeDate" v-if="!hideDateClearBtn">
            <i class="far fa-trash mr-2"></i>
            Remove
          </button>
        </div>
        <button class="btn btn-success btn-sm" @click="save">
          <i class="far fa-check mr-2"></i>
          Ok
        </button>
      </div>
    </div>
  </b-popover>
</div>
